import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        // Extending the summTreeColumn data filter to include custom refresh logic
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the filter display with the calculated sum.
                 * @param {Object} master - The master data table.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value containing column information.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) {
                            // Only consider level 1 objects
                            result += obj[value.columnId]; // Accumulate the sum
                        }
                    });
                    // Format the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result); // Integer format
                    } else {
                        if (value.columnId === 'Profitness') {
                            resultFormat = webix.i18n.numberFormat(result) + '%'; // Percentage format
                        } else {
                            resultFormat = webix.i18n.priceFormat(result); // Price format
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node display
                },
            },
            webix.ui.datafilter.summColumn, // Inherit from summColumn
        );

        // Return the main layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table for jackpot report
                            id: 'datatable', // Unique ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            columns: [
                                // Column definitions
                                {
                                    id: 'JackpotId',
                                    header: _('ID Jackpot'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'JackpotName',
                                    header: _('Nombre'), // Localized header
                                    width: 300,
                                    sort: 'text',
                                },
                                {   id: "PlayerId",
                                    header: _("ID de Usuario"),
                                    width: 300,
                                    sort: "text"
                                },
                                {
                                    id: 'StartDate',
                                    header: _('Fecha Inicio'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 250,
                                    sort: 'text',
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'DropDate',
                                    header: _('Fecha Caída'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 250,
                                    sort: 'text',
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'BetNumber',
                                    header: _('Numero de Apuesta'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'PrizeValue',
                                    header: _('Valor Premio'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Localized header
                                    width: 200,
                                    sort: 'text',
                                },
                                {
                                    id: 'BalanceType',
                                    header: _('Tipo de Saldo'), // Localized header
                                    width: 200,
                                    sort: 'text',
                                },
                                {
                                    id: 'Verticals',
                                    header: _('Verticales'), // Localized header
                                    width: 200,
                                    sort: 'text',
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            /**
                             * Event triggered when the table is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: true, // Enable vertical scrolling
                            height: 0, // Initial height
                            view: 'treetable', // Tree table for detailed report
                            id: 'datatable2', // Unique ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                // Column definitions for the tree table
                                {
                                    id: 'Supplier',
                                    header: _('Proveedor'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text',
                                    format: dateFormat, // Date formatting
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            // Check if the row is a group
                                            return (
                                                common.treetable(obj, common) + obj.value // Return group template
                                            );
                                        return obj.Supplier; // Return supplier name
                                    },
                                },
                                {
                                    id: 'Subsupplier',
                                    header:_('Subproveedor'), // Header for subsupplier
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Game',
                                    header:_('Juego'), // Header for game
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Award',
                                    header: _('Premio'), // Header for award
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Ggr',
                                    header: _('Ggr'), // Header for GGR
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'PercentageGgr',
                                    header: _('% Ggr'), // Header for percentage GGR
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            /**
                             * Event triggered when the tree table is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: {
                                size: 10000, // Page size
                                id: 'pagerr', // Pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main data table.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main data table
        var grid2 = $$('datatable2'); // Reference to the secondary tree table
        var url = devConfig.geturlApi() + 'es/Report/GetJackpotWinnersReport'; // API URL for jackpot winners report
        var url2 = devConfig.geturlApi() + 'es/Report/GetJackpotWinnersReport'; // API URL for jackpot winners report
        var flag = false; // Flag for export operation
        var vthis = this; // Reference to the current instance
        grid2.hide(); // Hide the secondary grid initially
        $$('toolbar1').hide(); // Hide the first toolbar
        var filter = ''; // Initialize filter string

        // Event listener for filtering the report
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String for date filters
            var string2 = ''; // String for sorting filters
            var providergroup = 0; // Provider group flag

            // Loop through filter data to construct query strings
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[Username]='; // Sort by username
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Stakes]='; // Sort by stakes
                            } else {
                                if (object[i][1] == '4') {
                                    string2 = string2 + '&sort[Winnings]='; // Sort by winnings
                                }
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'DropDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&DropDateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&DropDateTo=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        '-' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        '-' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            '-' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                // If not in provider group
                grid.show(); // Show main grid
                grid2.hide(); // Hide secondary grid
                grid.clearAll(); // Clear existing data
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse JSON response
                    var columnsGrid = []; // Array to hold column IDs
                    grid.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Collect column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Identify missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            if (id != 'detailTittle') {
                                grid.hideColumn(id); // Hide missing columns
                            }
                        });
                        grid.refreshColumns(); // Refresh column display
                    }
                });
                $$('toolbar1').show(); // Show first toolbar
                $$('toolbar2').hide(); // Hide second toolbar
            } else {
                grid2.show(); // Show secondary grid
                grid.hide(); // Hide main grid
                grid2.clearAll(); // Clear existing data
                grid2.load(url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse JSON response
                    var columnsGrid = []; // Array to hold column IDs
                    grid2.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Collect column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Identify missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            grid2.hideColumn(id); // Hide missing columns
                        });
                        grid2.refreshColumns(); // Refresh column display
                    }
                });
                grid2.adjust(); // Adjust grid layout
                $$('toolbar2').show(); // Show second toolbar
                $$('toolbar1').hide(); // Hide first toolbar
            }
            filter = string1 + string2; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for sorting the main grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });

        // Event listener for export filtering
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst; // Variable for first record
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first record
            } else {
                firstfirst = filterData.first; // Keep first record
            }
            grid.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            grid.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        // If export flag is set
                        var size = grid.getPager().config.size; // Get page size
                        var page = grid.getPage(); // Get current page
                        var first = size * page; // Calculate first record index
                        var last = first + size - 1; // Calculate last record index
                        if ($$('Export1').getValue() == '1') {
                            // Check export type
                            console.log('Entro'); // Log entry
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Casino') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel', // Set report type to Excel
                                },
                            ]);
                            webix.toExcel(grid, {
                                filter: function (obj) {
                                    return (
                                        grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter records for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Casino'),
                                ignore: { detailTittle: true, Type: true }, // Ignore specific columns
                                footer: false, // Do not include footer
                            });
                        } else {
                            if ($$('Export1').getValue() == '2') {
                                // Check export type
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Casino') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF', // Set report type to PDF
                                    },
                                ]);
                                webix.toPDF(grid, {
                                    filter: function (obj) {
                                        return (
                                            grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter records for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Casino'),
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true, Type: true }, // Ignore specific columns
                                    footer: false, // Do not include footer
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export1').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context
            );
        });

        // Event listener for displaying user information in a popup
        this.on(this.app, 'popupUserIframe', (id) => {
            webix
                .ui({
                    view: 'window', // Create a window for the popup
                    id: 'popupUserIframe', // Unique ID for the popup
                    head: {
                        view: 'toolbar', // Toolbar for the popup header
                        cols: [
                            {
                                view: 'label',
                                label: _('Información'), // Localized label
                                align: 'center',
                            },
                            {
                                view: 'icon',
                                icon: 'wxi-close', // Close icon
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                    position: 'center', // Center the popup
                    modal: true, // Make the popup modal
                    body: {
                        view: 'iframe', // Iframe for displaying user information
                        id: 'frame-body', // Unique ID for the iframe
                        src: '/#!/top/customers?user=' + id + '/information', // Source URL for the iframe
                    },
                })
                .show(); // Show the popup
            $$('popupUserIframe').setPosition(15, 15); // Set position of the popup
            $$('popupUserIframe').$setSize($(window).width() - 30, $(window).height() - 30); // Set size of the popup
        });
    }
}

// FILE DOCUMENTED
